var els = $('.services_list');
if (els.length > 0) {
  require.ensure('../controllers/edit_user_controller', function(require) {
    var EditUserController = require('../controllers/edit_user_controller');
    els.each(function() {
      return new EditUserController(this);
    });
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/edit_user.initializer.js